module.exports = __webpack_public_path__ + "assets/img/index-partner9.6c02338d.jpg";